import React from "react";

function W4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="327"
      height="20"
      fill="none"
      viewBox="0 0 327 20"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M99.31.513h227.109v.837H99.713L85.07 19.77H.675v-.836h83.99L99.309.514z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default W4;